import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { FaEnvelope } from 'react-icons/fa';

import { constructURLParams } from 'utils';
import event from 'utils/event';
import { GREEN } from 'root/theme';

import ShareButton from '../ShareButton';


export default class EmailShareButton extends Component {
  onClick = (e) => {
    const {
      user,
      text,
      link,
      urlParams,
      source,
    } = this.props;

    e.preventDefault();

    let shareLink = link || `https://www.quizhive.com/referral/${user ? user.username : ``}`;
    shareLink = `${shareLink}?${constructURLParams(urlParams)}`;
    const shareBody = `${text} ${shareLink}`.replace(/\n {6}/g, ` `);
    event(`share`, [`click`, `share-email`, source]);

    const subject = encodeURIComponent(`Do you like trivia as much as me?`);

    window.location = `mailto:?subject=${subject}&body=${encodeURIComponent(shareBody)}`;
  }

  render() {
    return (
      <ShareButton
        background={GREEN}
        onClick={this.onClick}
        circle={this.props.circle}
      >
        <FaEnvelope size="1.5em" />
      </ShareButton>
    );
  }
}

EmailShareButton.propTypes = {
  user: PropTypes.object,
  text: PropTypes.string.isRequired,
  source: PropTypes.string.isRequired,
  urlParams: PropTypes.object.isRequired,
  link: PropTypes.string,
  circle: PropTypes.bool,
};
